import Modal from '@material-ui/core/Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './geolocation-permission-modal.scss';

export type GeolocationPermissionModalState = 'prompt' | 'denied';

export interface GeolocationPermissionModalProps {
    state?: GeolocationPermissionModalState;
    onConfirm: () => void;
    onRetry: () => void;
    onContinueWithout: () => void;
}

const I18N_PREFIX = 'anticipation-simulation.anticipation-request-confirmation.geolocation';

export const GeolocationPermissionModal = (props: GeolocationPermissionModalProps) => {
    const { state, onConfirm, onRetry, onContinueWithout } = props;
    const { t } = useTranslation();

    return (
        <Modal open={!!state} disableBackdropClick disableEscapeKeyDown>
            <div className="geolocation-permission-modal">
                <div className="geolocation-permission-modal__content">
                    <div className="geolocation-permission-modal__title">{t(`${I18N_PREFIX}.${state ?? 'prompt'}.title`)}</div>
                    <div className="geolocation-permission-modal__text">{t(`${I18N_PREFIX}.${state ?? 'prompt'}.text`)}</div>
                    {state === 'denied' ? (
                        <div className="geolocation-permission-modal__buttons">
                            <button className="geolocation-permission-modal__button--secondary" onClick={onContinueWithout}>
                                {t(`${I18N_PREFIX}.denied.continue`).toUpperCase()}
                            </button>
                            <button className="geolocation-permission-modal__button--primary" onClick={onRetry}>
                                {t(`${I18N_PREFIX}.denied.retry`).toUpperCase()}
                            </button>
                        </div>
                    ) : (
                        <div className="geolocation-permission-modal__buttons">
                            <button className="geolocation-permission-modal__button--primary" onClick={onConfirm}>
                                {t(`${I18N_PREFIX}.prompt.confirm`).toUpperCase()}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default GeolocationPermissionModal;
